import React from 'react'
import {
  BrowserRouter,
  Routes as RoutesSwitch,
  Route,
  Navigate,
  Outlet,
} from 'react-router-dom'
import { IntroPage } from '../pages/IntroPage'
import { LoadPage } from '../pages/LoadPage'
import { EditPage, StepContent } from '../pages/EditPage'
import { ThankYouPage } from '../pages/ThankYouPage'
import { LoginPage } from '../pages/LoginPage'
import { LogoutPage } from '../pages/LogoutPage'
import GroupListPage from '../pages/GroupListPage'
import GroupPage from '../pages/GroupPage'
import UserListPage from '../pages/UserListPage'

export const AppRoutes = {
  login: (): string => '/',
  intro: (): string => '/intro',
  logout: (): string => '/logout',
  create: (): string => '/create',
  edit: (): string => '/edit',
  load: (): string => '/load',
  editStyle: (): string => '/edit/style',
  editCatalog: (): string => '/edit/catalog',
  editProducts: (): string => '/edit/products',
  editConfirmation: (): string => '/edit/confirmation',
  thankYou: (): string => '/edit/thank-you',
  groupList: (): string => '/groups',
  userList: (): string => '/users',
  groupPage: (): string => '/groups/:id',
}

export const Routes: React.FC = () => {
  return (
    <BrowserRouter basename={'/'}>
      <RoutesSwitch>
        <Route path={AppRoutes.login()} element={<LoginPage />} />
        <Route element={<PrivateRoute />}>
          <Route path={AppRoutes.intro()} element={<IntroPage />} />
          <Route path={AppRoutes.logout()} element={<LogoutPage />} />
          <Route path={AppRoutes.load()} element={<LoadPage />} />
          <Route path={AppRoutes.edit()} element={<EditPage />}>
            <Route
              path={`${AppRoutes.edit()}/:step`}
              element={<StepContent />}
            />
          </Route>
          <Route path={AppRoutes.create()} element={<EditPage />}>
            <Route
              path={`${AppRoutes.create()}/:step`}
              element={<StepContent isNewProduct />}
            />
          </Route>
          <Route path={AppRoutes.thankYou()} element={<ThankYouPage />} />
          <Route path={AppRoutes.groupList()} element={<GroupListPage />} />
          <Route path={AppRoutes.userList()} element={<UserListPage />} />
          <Route path={AppRoutes.groupPage()} element={<GroupPage />} />
        </Route>
      </RoutesSwitch>
    </BrowserRouter>
  )
}

const PrivateRoute = () => {
  const userToken = localStorage.getItem('userToken')
  return userToken ? <Outlet /> : <Navigate to="/" replace />
}
